<template>
    <div>
        <b-row>
            <b-col sm="9">
                <router-view></router-view>
            </b-col>
            <b-col>

                <b-card :no-body="true">
                    <b-card-body class="p-2 clearfix">
                        <i class="fa-duotone fa-coin-blank bg-secondary p-3 font-2xl mr-3 float-left"></i>
                        <div class="h4 mb-0 mt-2">
                            <b-link to="/pricing/coin-pricing">Coin Pricing</b-link>
                        </div>
                    </b-card-body>
                </b-card>

                <b-card :no-body="true">
                    <b-card-body class="p-2 clearfix">
                        <i class="fa-duotone fa-gem bg-secondary p-3 font-2xl mr-3 float-left"></i>
                        <div class="h4 mb-0 mt-2">
                            <b-link to="/pricing/diamond-pricing">Diamond Pricing</b-link>
                        </div>
                    </b-card-body>
                </b-card>

            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: 'pricing-index',
        title: 'Pricing',
        data() {
            return {
                inputOrder: '',
                printing: false,
                printingMessage: null,
            };
        },
        created() {

        },
        methods: {

        },
    };
</script>

<style scoped>

</style>
